// removed by extract-text-webpack-plugin
module.exports = {"promo-table":"style__promo-table___b59_1","edit-link":"style__edit-link___1TS2J","delete-link":"style__delete-link___3yqYf","promo-to-delete":"style__promo-to-delete___2e8oB"};


//////////////////
// WEBPACK FOOTER
// ./components/PromotionList/style.scss
// module id = 1387
// module chunks = 0